import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';

interface IPmResultProps {
  passportData?: IKnmPreview;
}

export const PmResult = ({ passportData }: IPmResultProps) => (
  <div className={styles.ColumnContent}>
    {passportData?.pmErknm && passportData?.pmErknm.resultOfInspection && (
      <KnmSubtitle title="Сведения о результатах профилактического мероприятия">
        {passportData?.erpId && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Результат профилактического мероприятия</div>
            <div className={styles.ColValue}>{passportData?.pmErknm.resultOfInspection}</div>
          </div>
        )}
      </KnmSubtitle>
    )}
  </div>
);
